import { FC, ReactNode } from 'react'

import { cn } from '@bem-react/classname'

import './Card.scss'

interface ICardProps {
  className?: string
  children?: ReactNode
}

const cnCard = cn('Card')

export const Card: FC<ICardProps> = ({ className, children }) => {
  return <div className={cnCard(null, [className])}>{children}</div>
}
